import React from 'react';
import {Redirect} from 'react-router';

const Welcome = () => {
    return <Redirect to='/new' />;
};

export default Welcome;